import { tap, withLatestFrom } from 'rxjs';
import { enterPressed } from '@ardoq/dropdown-menu';
import {
  action$,
  dispatchAction,
  extractPayload,
  ofType,
  withNamespace,
} from '@ardoq/rxbeach';
import { GetAdditionalRoutineArgs } from '../../types';
import { NodeModelTypes } from '../../utils/consts';
import {
  componentTreeSelectionChanged,
  selectionStartSet,
  selectionToggle,
} from '@ardoq/component-selection';
import { CREATE_COMPONENT_NODE_ID } from '../../models/CreateComponentNode';

export const getHandleEnterPressedMultiselectRoutine = ({
  navigator$,
  navigatorConfiguration,
}: GetAdditionalRoutineArgs) =>
  action$.pipe(
    withNamespace(navigatorConfiguration.actionNamespace),
    ofType(enterPressed),
    extractPayload(),
    withLatestFrom(navigator$),
    tap(([{ nodeId }, state]) => {
      const resolvedNodeId = nodeId || state.tree.keyboardSelectedNodeId || '';

      if (resolvedNodeId === CREATE_COMPONENT_NODE_ID) {
        const createComponentNode = state.tree.getCreateComponentNode();
        const newComponentName = createComponentNode?.getName() ?? '';
        const { onCreateNewComponent } = navigatorConfiguration.eventHandlers;
        if (newComponentName && onCreateNewComponent) {
          onCreateNewComponent(newComponentName);
        }
        return;
      }

      const highlightedNode = state.tree.getNode(resolvedNodeId);
      if (!highlightedNode) {
        return;
      }
      if (highlightedNode.type === NodeModelTypes.COMPONENT) {
        if (!highlightedNode.isSelectable || highlightedNode.isDisabledOption) {
          return;
        }
        if (!navigatorConfiguration.isMultiselectable) {
          dispatchAction(
            componentTreeSelectionChanged({
              treeSelection: [highlightedNode.id],
            }),
            navigatorConfiguration.actionNamespace
          );
          return;
        }
        dispatchAction(
          selectionToggle({ nodeId: highlightedNode.id }),
          navigatorConfiguration.actionNamespace
        );
        dispatchAction(
          selectionStartSet({ selectionStart: highlightedNode.id }),
          navigatorConfiguration.actionNamespace
        );
      }
      // TODO handle workspace nodes
    })
  );
